import UniversalLoader from "./UniversalLoader.js";
import * as _ from "lodash";

/**
 * Instanzen dieser Klasse müssen createMaterial implementieren und können an UniversalLoader.setMaterialFactory
 * übergeben werden. Somit kann z.B. einmalig eine MTL Datei geladen werden, oder die Materialien werden
 * programmatisch erzeugt. Es können auch Factories per Delegation verkettet werden. Falls diese
 * Instanz kein Material liefert, wird an die delegateMaterialFactory weitergeleitet
 */
export default class AbstractMaterialFactory {

    /**
     * @param texture_root Der Basispfad, aus dem die Texturen geladen werden
     * @param delegateMaterialFactory Falls diese Instanz kein Material zu einem Namen liefert, wird an die delegateMaterialFactory weitergeleitet
     */
    constructor(texture_root,delegateMaterialFactory=null) {
        this.texture_root = texture_root;
        this.delegateMaterialFactory = delegateMaterialFactory;
        this.materials = {};
    }

    /**
     * Erzeugt ein Material zu einem Namen, falls es nicht im Cache ist.
     * Delegiert an die delegateMaterialFactory weiter, wenn createMaterial_(materialName) kein Material liefert.
     */
    create(materialName) {
        materialName = materialName || 'default';
        if (!this.materials[materialName]) {
            this.materials[materialName] = this._createMaterial(materialName);
        }
        if (!this.materials[materialName] && this.delegateMaterialFactory) {
            this.materials[materialName] = this.delegateMaterialFactory.create(materialName);
        }
        if (this.materials[materialName]==null) {
            this.materials[materialName] = new THREE.MeshStandardMaterial();
            this.materials[materialName].name = materialName;
            this.materials[materialName].userData._no_material_with_this_name_found = materialName;
            // logging ausgeschaltet, weil Normalfall bei externen Objekten mit enthaltenen Materialien (GTLF)
            // console.warn('MaterialFactory: found no material named '+materialName);
        }
        return this.materials[materialName];
    }

    /**
     * Muss überschrieben werden
     */
    _createMaterial(materialName) {
        throw "not yet implemented";
    }

    /** */
    loadTextureCube(images, onLoad=undefined, onError=undefined) {
        return UniversalLoader.loadTextureCube(images.map(img=>this.texture_root+img), undefined, onLoad, onError);
    }

    /** */
    loadTexture(path, onLoad=undefined, onError=undefined) {
        let url = this.getTextureUrl(path);
        return UniversalLoader.loadTexture(url, undefined, onLoad, onError);
    }

    getTextureUrl(path) {
        return (/^(http|https|file):\/\/.*$/.test(path))
            ? path
            : this.texture_root + path;
    }

    /** */
    clearMaterialsCache() {
        this.materials = {};
    }

    /**
     * Muss überschrieben werden
     */
    getAllKnownMaterialNames() {
        throw "not yet implemented";
    }

    /**
     */
    replaceMaterial(material) {
        if (this.materials[material.name]) {
            this.materials[material.name] = material;
        }
        if (this.delegateMaterialFactory?.replaceMaterial) {
            this.delegateMaterialFactory.replaceMaterial(material);
        }
    }

}
